import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { PublicBoxComponentGroupCosmeticBrandResponse } from './public-box-component-group-cosmetic-brand.response';

@jsonObject
export class PublicBoxComponentGroupCosmeticResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Number)
  public readonly amount?: Nillable<number>;

  @jsonMember(PublicBoxComponentGroupCosmeticBrandResponse)
  public readonly cosmeticBrand?: Nillable<PublicBoxComponentGroupCosmeticBrandResponse>;

  @jsonMember(MultimediaResponse)
  public readonly featureFile?: Nillable<MultimediaResponse>;
}
